import { render, staticRenderFns } from "./regularbox.vue?vue&type=template&id=87caf7d0&scoped=true&"
import script from "./regularbox.vue?vue&type=script&lang=js&"
export * from "./regularbox.vue?vue&type=script&lang=js&"
import style0 from "./regularbox.vue?vue&type=style&index=0&id=87caf7d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87caf7d0",
  null
  
)

export default component.exports